import { useQuery } from "@tanstack/react-query"
import { Axios } from "../utils/Axios"


export const useCustomers = (page, limit, name) => {
    return useQuery({
        queryKey: ['customers'],
        queryFn: async () => {
            const res = await Axios.get('/customer/all', { params: { page, limit, name } });
            return res.data;
        }
    })
}